import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Tabs,
  Tab,
  IconButton,
  Box,
  useMediaQuery,
} from "@mui/material";
import { Notifications, AccountCircle, Settings } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import ActiveDashboard from "../../assets/dashboardactiveIcon.svg";
import LogOutIcon from "../../assets/Logout.svg";
import { logOut } from "../../apiSection/util";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Popover from "@mui/material/Popover";
import { logout } from "../ReduxStore/UserStore";
import SetPassword from "../../Pages/SetPassword";
import CustomModal from "./modal";


const Header = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTabName, setActiveTabName] = useState(1);
  const [anchorEl, setAnchorEl] = useState("");
  const [openModal, setOpenModal] = useState(false);
    
  const dispatch = useDispatch();
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCreatePop = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const userData = useSelector((state) => state.auth.user);
  const { t, i18n } = useTranslation("common");
  let MenuItems = [
    {
      menuName: userData !=null && userData?.role_id === 1 ? t("dashboard") : "Dashboard",
      menuIconActive: ActiveDashboard,
      menuIconInActive: ActiveDashboard,
      menuId: 1,
      path: "/dashboard/management",
    },
  ];
  const changeHandler = (data) => {
    setActiveTabName(data.menuId);
    props.Redirectpath(data.path);
  };
  const handleLogout = () => {
    logOut();
    dispatch(logout());
    props.Redirectpath("/");
  };
  const handlePath = () => {
    props.Redirectpath("/dashboard/createUser");
  };
  const handleUpdatePassword = ()=>{
    setAnchorEl(null);
    setOpenModal(true)
  }
  const handleCloseModal = ()=>{
    setOpenModal(false)
  }
  React.useEffect(() => {
    if (i18n && i18n.changeLanguage) {
      const stateId = userData && userData.state_id;
      if (stateId === 2) {
        i18n
          .changeLanguage("tam")
          .catch((err) => console.error("Error switching to Tamil:", err));
      } else if (stateId === 1) {
        i18n
          .changeLanguage("guj")
          .catch((err) => console.error("Error switching to Gujarati:", err));
      } else if (stateId === 3) {
        i18n
          .changeLanguage("tri")
          .catch((err) => console.error("Error switching to Tripura:", err));
      }else if (stateId === 5) {
        i18n
          .changeLanguage("miz")
          .catch((err) => console.error("Error switching to Mizoram:", err));
      } else {
        i18n
          .changeLanguage("en")
          .catch((err) => console.error("Error switching to English:", err));
      }
    }
  }, [userData]);

  const newPassword=()=>{
    console.log("Edit Password")
  }

  return (
    <AppBar position="fixed" color="inherit" elevation={1}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Left Side - Title */}
        <Typography variant="h6" color="primary" sx={{ fontWeight: "bold" }}>
          {userData?.role_id === 1 ? t("ticketingTool") : "Ticketing Tool"}
        </Typography>

        {/* Middle - Tabs */}
        <div
          style={{
            marginLeft: theme.spacing(2),
            display: isSmallScreen ? "none" : "flex",
            alignItems: "center",
          }}
        >
          {MenuItems &&
            MenuItems.length > 0 &&
            MenuItems.map((mdata) => (
              <div
                onClick={() => {
                  changeHandler(mdata);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: theme.spacing(2),
                  backgroundColor:
                    activeTabName === mdata.menuId ? "#e5f0ff" : "#ffff",
                  height: "50px",
                  borderRadius: "8px",
                  padding: "0px 10px",
                  cursor: "pointer",
                }}
              >
                <img
                  src={
                    activeTabName === mdata.menuId
                      ? mdata.menuIconActive
                      : mdata.menuIconInActive
                  }
                  width="100%"
                />
                <span style={{ padding: "0px 10px" }}>{mdata.menuName}</span>
              </div>
            ))}
        </div>

        {/* Right Side - Icons */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {/* <div>
            <AccountCircle />
            </div> */}
          <div>
            <div
              style={{
                fontFamily: "Arial, sans-serif",
              }}
            >
              <div
                style={{
                  display: "flex",
                }}
              >
                <span style={{ fontWeight: "bold", color: "#2c3e50" }}>
                {userData?.role_id === 1 ? t("name") : "Name"}
                :
                </span>
                <span
                  style={{
                    fontSize: "16px",
                    color: "#34495e",
                    // textAlign: "right",
                  }}
                >
                  
                  {`${userData?.FName} ${userData?.LName}`}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ fontWeight: "bold", color: "#2c3e50" }}>
                {userData?.role_id === 1 ? t("dashEmail") : "Email"}
                :
                </span>
                <span
                  style={{
                    fontSize: "16px",
                    color: "#34495e",
                    // textAlign: "right",
                  }}
                >
                  {userData && userData.email}
                </span>
              </div>
            </div>
          </div>

          <IconButton color="inherit">
            {/* <Notifications color="error" />{" "} */}
            {/* Add a color prop to make it red */}
          </IconButton>

          <IconButton color="inherit" >
            <Settings onClick={handleCreatePop} />
          </IconButton>
          
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center", 
            }}
            sx={{
              mt: 1, 
            }}
          >
            {(userData.role_id === 11 || userData.role_id === 14) &&<Typography onClick={handlePath} sx={{ p: 1,cursor:"pointer" }}>Users</Typography>}

            <Typography onClick={handleUpdatePassword} sx={{ p: 1,cursor:"pointer" }}>Update Password</Typography>
          </Popover>
          <IconButton color="inherit" onClick={handleLogout}>
            <img src={LogOutIcon} />
          </IconButton>
        </Box>
        <CustomModal
        open={openModal}
        handleClose={handleCloseModal}
        modalTitleRequired={true}
        width="380px"
        height="auto"
        modalContent={
          <div>
            <SetPassword Redirectpath={props.Redirectpath} newPassword={newPassword}/>
          </div>
        }
      />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
